import { useEffect, useState } from 'react';
import {
  Center,
  Box,
  Title,
  Button,
  Space,
  Table,
  Image,
  Group,
  Text,
  Stack,
  Divider,
} from '@mantine/core';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import QRCode from 'qrcode.react';
import dayjs from 'dayjs';
import Logo from '../../image/hyperthings-logo.png';
import { sendRequest } from '../../services/services';
import './invoice.css';

const PaymentStatus = ({ invoiceDataId, passDataId, profile, isRefund }) => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const [ticketData, setTicketData] = useState();
  const [invoiceData, setInvoiceData] = useState();
  const [, setInvoiceId] = useState();
  const Pass = invoiceDataId;
  const passIdData = passDataId;

  // const invoiceFetch = () => {

  // };
  useEffect(() => {
    sendRequest(`cashier/invoice/${Pass}`, 'get').then((res) => {
      setInvoiceData(res?.data || []);
      setInvoiceId(res);
    });
  }, [Pass]);

  const invoicePrint = () => {
    // if (invoiceId?.msg === 'invoice Found!') {
    window.print();
    navigate('/home');
    window.location.reload();
    // }
  };

  useEffect(() => {
    sendRequest(`cashier/reservations-by-pass-id/${passIdData}`, 'get').then((res) => {
      setTicketData(res?.data?.result || []);
    });
  }, [passIdData]);

  const now = dayjs();

  const rows = invoiceData?.invoice_items.map((element) => (
    <tr key={element.name}>
      {/* <td>{element.invoice_item_list?.name}</td> */}
      <td>{(Number(element?.amount) + (Number(element?.amount) * Number(15)) / 100).toFixed(2)}</td>
      <td>{((Number(element?.amount) * Number(15)) / 100).toFixed(2)}</td>
      <td>{Number(element?.unit_price).toFixed(2)}</td>
      <td>{element?.unit}</td>
      <td>
        {element.invoice_item_list?.name === 'Reservation'
          ? 'Parking'
          : element.invoice_item_list?.name}
      </td>
    </tr>
  ));

  const enfoRows = ticketData?.enforcements.map((em) => (
    <tr key={em.name}>
      {/* <td>{element.invoice_item_list?.name}</td> */}
      <td>{em?.name}</td>
      <td>{Number(em?.amount).toFixed(2)}</td>
      <td>{em ? 1 : 0}</td>
      <td>{Number(em?.amount).toFixed(2)}</td>
    </tr>
  ));

  return (
    <Box>
      <div className="printme">
        <Stack align="center" spacing={0}>
          <Image src={Logo} width={200} py="md" />
          <Group position="apart">
            <Text>{now.format('DD/MM/YY')}</Text>
            <Text>{now.format('hh:mma')}</Text>
          </Group>
          <Text>
            {profile?.user__site__assign?.filter((item) => item?.is_active)[0]?.sites?.name}
          </Text>
          <Text>{ticketData?.sites?.name}</Text>
          <Text>**********************************</Text>
          {isRefund ? (
            <Stack>
              <Title order={5}>فاتورة الاسترجاع</Title>
              <Title order={5}>Refund Invoice</Title>
            </Stack>
          ) : (
            <Stack>
              <Title order={5}>فاتورة ضريبية مبسطة</Title>
              <Title order={5}>Simplified Tax Invoice</Title>
            </Stack>
          )}
          <Group>
            <Text>{t('payment.status.invoice.print.vat.number.text')}</Text>
            <Text>
              {profile?.user__site__assign?.filter((item) => item?.is_active)[0]?.sites?.vat_no}
            </Text>
          </Group>
          <Text>*******************************************</Text>
        </Stack>
        <Stack>
          <Group>
            <Text>Invoice Number:</Text>
            <Text>{invoiceData?.id}</Text>
          </Group>
          <Group>
            <Text>Payment Type:</Text>
            <Text>{invoiceData?.payment_transactions?.[0]?.payment_types?.name}</Text>
          </Group>
        </Stack>
        <Divider my="sm" size="md" color="#0000000" variant="dashed" />

        <Box>
          <Center>
            <Table>
              <thead>
                <tr>
                  <th>
                    <Text weight={700} size="sm">
                      القيمة
                    </Text>
                  </th>
                  <th>
                    <Text weight={700} size="sm">
                      الضريبة
                    </Text>
                  </th>
                  <th>
                    <Text weight={700} size="sm">
                      تكلفة الوحدة
                    </Text>
                  </th>
                  <th>
                    <Text weight={700} size="sm">
                      الكمية
                    </Text>
                  </th>
                  <th>
                    <Text weight={700} size="sm">
                      التفاصيل
                    </Text>
                  </th>
                </tr>
              </thead>
              <tbody>
                {rows} {enfoRows}
              </tbody>
            </Table>
          </Center>
          <Divider my="sm" size="md" color="#0000000" variant="dashed" />

          <Group position="apart">
            <Stack>
              <Text size="md" weight={500}>
                {Number(invoiceData?.total_amount).toFixed(2)}
              </Text>
              <Text size="md" weight={500}>
                {Number(invoiceData?.tax).toFixed(2)}
              </Text>
              {invoiceData?.refunded_amount ? (
                <Text size="md" weight={500}>
                  - {Number(invoiceData?.refunded_amount).toFixed(2)}
                </Text>
              ) : null}
              <Text size="md" weight={500}>
                {Number(invoiceData?.paid_amount).toFixed(2)}
              </Text>
            </Stack>

            <Stack>
              <Text size="md" weight={700}>
                المجموع الفرعي
              </Text>
              <Text size="md" weight={700}>
                الضريبة ( 15% )
              </Text>
              <Text size="md" weight={700}>
                المبلغ المسترد
              </Text>
              <Text size="md" weight={700}>
                الإجمالي
              </Text>
            </Stack>
          </Group>
        </Box>
        <Divider my="sm" size="md" color="#0000000" variant="dashed" />
        <Divider
          my="sm"
          size="md"
          label={t('payment.status.invoice.print.invoice.qr.divider.label')}
          labelPosition="center"
          variant="dashed"
        />
        <Group>
          <Text>Cashier Name:</Text>
          <Text>{profile?.name}</Text>
        </Group>
        <Center py="xl">
          <QRCode
            value={JSON.stringify({
              ticket_Number: passIdData,
              invoice_Number: invoiceData?.id,
              vat_Number: profile?.user__site__assign?.filter((item) => item?.is_active)[0]?.sites
                ?.vat_no,
            })}
            renderAs="canvas"
          />
        </Center>
        <Center>
          <Text>powered by Hyperthings</Text>
        </Center>
        <Divider
          my="sm"
          size="md"
          label={t('payment.status.invoice.print.invoice.qr.divider.label')}
          labelPosition="center"
          variant="dashed"
        />
      </div>

      <Box className="no-printme">
        <Center>
          <Box
            sx={(theme) => ({
              textAlign: 'center',
              padding: theme.spacing.md,
            })}
          >
            <Center py="xl">
              <Group position="apart" style={{ marginBottom: 5, marginTop: 5 }}>
                <Button onClick={invoicePrint} color="blue" size="xl">
                  {t('payment.status.invoice.print.invoice.button.text')}
                </Button>
              </Group>
            </Center>
          </Box>
        </Center>
        <Space h="xl" />
        <Space h="md" />
      </Box>
    </Box>
  );
};
export default PaymentStatus;
